import React, { Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';
import Redirector from './features/redirect';

const Routes: React.FC = () => (
  <Suspense fallback={<div>Loading...</div>}>
    <Switch>
      <Route path={'/'} component={Redirector} />
    </Switch>
  </Suspense>
);

export default Routes;
